<template>
  <div class="advanced-options-card">
    <el-switch
      v-model="state.open"
      :width="110"
      on-text="Advanced"
      off-text="Advanced"
    />

    <el-card v-if="state.open" title="Advanced options">
      <slot />
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'advanced-options-card',
  props: {
    initialOpen: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      state: {
        open: false,
      },
    };
  },
  created() {
    this.state.open = this.initialOpen;
  },
};
</script>

<style scoped>
.advanced-options-card {
  margin-top: 5px;
}

.advanced-options-card .el-card {
  margin-top: 5px;
}
</style>